import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CtrlTooltipComponent, CtrlTooltipDirective } from '@co-3/ctrl-ui/tooltips';

@Component({
    selector: 'app-navigation-buttons',
    imports: [NgClass, CtrlTooltipDirective, CtrlTooltipComponent],
    templateUrl: './navigation-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationButtons {
    public showBack = input<boolean>(false);
    public nextTooltip = input<string>();
    public nextDisabled = input<boolean>(false);

    public prev = output<void>();
    public next = output<void>();
}
